import { render } from "./HowToInstall.vue?vue&type=template&id=7c7984d0"
import script from "./HowToInstall.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToInstall.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/HowToInstall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c7984d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c7984d0', __exports__)) {
    api.reload('7c7984d0', __exports__)
  }
  
  module.hot.accept("./HowToInstall.vue?vue&type=template&id=7c7984d0", () => {
    api.rerender('7c7984d0', render)
  })

}


export default __exports__